import { Configuration } from "../";
import tenantConfig from "tenants";

const configuration: Configuration = {
  api: {
    uri: process.env.REACT_APP_API_URL || "",
    apiKey: process.env.REACT_APP_API_KEY || "",
    tenantId: tenantConfig.tenantId,
  },
  fireBaseConfig: {
    apiKey: "AIzaSyBH_FuqlNxxvffPjLiiOIVUjBrcuPRBOic",
    authDomain: "arinorgau.firebaseapp.com",
    projectId: "arinorgau",
    appId: "1:597215957054:web:8f9a99ee307bf69694416f",
    measurementId: "G-N1PZGBZ700",
  },
  shouldCollectAnalyticsData: true,
  reCaptchaKey: "6LfKluIUAAAAAFJEzqPawgX71jCIrSgzGw5J-p_X",
} as const;

export default configuration;
